import React from 'react';
import ImageGallerskilldevelopment from '../components/ImageGallerskilldevelopment';
import IRCTVDonationCard from "./IRCTVDonationCard";



const IRCSKILL = () => {
      const skillBaseAmount = 100;

    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerskilldevelopment />

                    {/* Skill Development Programs */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>SKILL DEVELOPMENT PROGRAMS</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                In order to encourage underprivileged people of the society to take up industry-relevant skill training that will help them in securing a better livelihood, IRC organizes various skill development programs to enable them to start their own small scale businesses of manufacturing goods and earn to support their families.
                            </p>
                        </div>
                        <IRCTVDonationCard
                            title="SKILL DEVELOPMENT PROGRAMS"
                            baseAmount={skillBaseAmount}
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: SKILL DEVELOPMENT PROGRAMS"
                        />
                    </div>

                </section>
            </div>
        </>
    );
};

export default IRCSKILL;
